export default {"src":"/_next/static/media/Tumblr.89f32ce3.svg","height":21,"width":22,"blurWidth":0,"blurHeight":0};